import I18n from "i18next";
import OverViewWidget from "../Common/OverViewWidget";

const VerifiedApplications = ({ data, onClick }) => {
  return (
    <OverViewWidget
      title={I18n.t("overview.verifiedApplications")}
      legendText1={I18n.t("overview.applicationsReceived")}
      legendText2={I18n.t("overview.applicationsVerified")}
      bar2Color="#0099FF"
      bar1Color="#D3D3DF"
      downloadURL={data.url}
      data={data.data}
      type="acceptedCustomer"
      stackedGroup={true}
      menuSelect={onClick}
      spinner={data.spinner}
      tileName="verifiedApplications"
    />
  );
};

export default VerifiedApplications;
